var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"main"},[_c('div',[_c('on'),_c('Row',[_c('Col',{staticClass:"body",attrs:{"span":"24"}},[_c('router-view',{key:_vm.key})],1)],1),_c('up')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }